import { cn } from '@/lib/utils';
import React from 'react';

export const Skeleton = ({ className = '' }: { className?: string }) => (
  <div
    role="status"
    className={cn(
      'h-400 w-full animate-pulse rounded-400 bg-buttons-backgrounds-secondary-hover',
      className,
    )}
  />
);
